import reducer from './reducers';

export { default as quizSagas } from './sagas';
export { default as quizActions } from './actions';
export {
  attemptsSelector,
  correctQuestionAttemptsSelector,
  currentAttemptSelector,
  isFetchingAttemptsSelector,
  isSubmittingAnswerSelector,
  lastSubmittedAnswerSelector,
  latestQuizAttemptSelector,
  quizRelatedTasksSelector,
  questionsSelector
} from './selectors';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/quiz/index.js